<template>
    <asli-popup :show-close-button="false" v-model="displayModal" class="p-4">
        <div class="px-8 py-4">
            <p class="text-sm mb-[15px]">
                To ensure your session stays active, please avoid using the browser's navigation buttons. Instead, use
                the "Back" or "Continue" buttons, or other navigation options at the bottom of the page. Thank you!
            </p>
            <button-bar class="flex-col sm:flex-row">
                <asli-button id="browser-back-btn-cancel" color="primary" type="button" @click="handleModal(false)">
                    Cancel
                </asli-button>
                <asli-button id="browser-back-btn-continue" color="secondary" type="button" @click="handleModal(true)">
                    Continue
                </asli-button>
            </button-bar>
        </div>
    </asli-popup>
</template>

<script lang="ts" setup>
import { useMainStore } from "@/stores/main";
import { useProposalStore } from "@/stores/risk/risk";
import { AsliPopup, AsliButton } from "@mbs-npm/anpost-ui";
import { computed, watch } from "vue";
import ButtonBar from "@/components/ButtonBar.vue";
import { resolveNavigation, routeGuard } from "@/router";
import { useRouter } from "vue-router";
import { ROUTE_NAMES } from "@/router/types";

const mainStore = useMainStore();
const proposalStore = useProposalStore();
const router = useRouter();

const displayModal = computed({
    get: () => mainStore.displayBrowserNavigationModal,
    set: val => (mainStore.displayBrowserNavigationModal = val)
});

let prevRouteValueBeforeModalShown = mainStore.previousRoute?.name;

watch(
    () => mainStore.previousRoute?.name,
    (_newValue, oldValue) => {
        prevRouteValueBeforeModalShown = oldValue;
    },
    { deep: true }
);

const handleModal = async (confirm: boolean) => {
    mainStore.displayBrowserNavigationModal = false;

    if (resolveNavigation.value) {
        if (confirm) {
            if (
                router.currentRoute.value.name === ROUTE_NAMES.Declined &&
                prevRouteValueBeforeModalShown === ROUTE_NAMES.YourQuotes
            ) {
                await proposalStore.resetQuote();
            }
            resolveNavigation.value();
            routeGuard();
        } else {
            sessionStorage.setItem("forceStopNavigation", "true");
            resolveNavigation.value(false);
        }
        displayModal.value = false;
        resolveNavigation.value = null;
    }
};
</script>
